import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "warn2",
  "use": "warn2-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"warn2\"><defs><style type=\"text/css\"></style></defs><path d=\"M512 176c-194.4 0-352 157.6-352 352 0 194.416 157.6 352 352 352s352-157.584 352-352C864 333.584 706.4 176 512 176zM512 720.592c-22.304 0-40.384-18.08-40.384-40.384 0-22.304 18.08-40.384 40.384-40.384 22.32 0 40.384 18.096 40.384 40.384C552.384 702.512 534.32 720.592 512 720.592zM534.256 589.504c-3.504 10.992-12.32 18-22.256 18-9.952 0-19.248-8.512-22.256-18C486.752 579.984 464 431.68 464 368.688c0-16 16-48.992 47.504-48.992S560 352.192 560 368.688C560 432.176 537.744 578.496 534.256 589.504z\" p-id=\"2104\" fill=\"#4d82fb\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/warn2.svg
// module id = YM2A
// module chunks = 37